.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 2px solid rgb(var(--primaryColor));
  background: var(--mi-neutral-40);
  cursor: default;

  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
}

.avatarButton {
  cursor: pointer;
}

.avatarButton:focus-visible {
  outline: 4px solid color-mix(in srgb, var(--mi-brand-main) 50%, transparent);
}
